module.exports = __webpack_public_path__ + "static/assets/f66c9c4250f83c115821fdaad2c0d49c.png";